import React, { useState } from 'react';
import { cn } from '../../utils/cn';

const SIZES = {
  xs: 'w-5 h-5  text-[9px]',
  sm: 'w-6 h-6  text-[10px]',
  md: 'w-8 h-8  text-[12px]',
  lg: 'w-10 h-10 text-[14px]',
  xl: 'w-14 h-14 text-[16px]',
};

function initialsOf(name = '') {
  return name.trim().split(/\s+/).map(s => s[0]).filter(Boolean).slice(0, 2).join('').toUpperCase();
}

export function Avatar({ src, alt, name, size = 'md', shape = 'circle', className, ...rest }) {
  const [errored, setErrored] = useState(false);
  const fallback = initialsOf(alt || name);
  const shapeCls = shape === 'square' ? 'rounded-md' : 'rounded-full';

  return (
    <span
      className={cn(
        'inline-flex items-center justify-center overflow-hidden font-semibold select-none',
        'bg-ink text-cream shrink-0',
        SIZES[size],
        shapeCls,
        className
      )}
      aria-label={alt || name}
      {...rest}
    >
      {src && !errored ? (
        <img src={src} alt={alt || name} className="w-full h-full object-cover" onError={() => setErrored(true)} />
      ) : (
        <span aria-hidden>{fallback || '?'}</span>
      )}
    </span>
  );
}

export function AvatarGroup({ children, max = 4, size = 'md', className }) {
  const items = React.Children.toArray(children);
  const visible = items.slice(0, max);
  const overflow = items.length - visible.length;
  return (
    <div className={cn('inline-flex items-center', className)}>
      {visible.map((c, i) => (
        <span key={i} className={cn('relative -ml-2 first:ml-0 ring-2 ring-bg rounded-full')}>
          {React.cloneElement(c, { size })}
        </span>
      ))}
      {overflow > 0 && (
        <Avatar
          size={size}
          name={`+${overflow}`}
          className="-ml-2 ring-2 ring-bg bg-cream-3 text-text"
        />
      )}
    </div>
  );
}

Avatar.Group = AvatarGroup;
export default Avatar;
